<template>
    <div class="funnel-app-preview layout-column noscroll">
        <div class="head">
            <h2>Preview</h2>
            <span class="subheadline">This is how the app will look like on your funnel:</span>
        </div>
        <div class="content noscroll flex layout-column">
					<component v-if="componentName" :is="componentName" :app="app" :newUserApp="newUserApp" :user-app="userApp"></component>

	        <div v-else class="layout-column flex noscroll">

		        <div class="layout-column flex scroll">
			        <div class=" alert_box orange" style="margin: auto 20px;">
	                <span class="icon">
	                    <inline-svg :src="require('@/assets/img/alert_icon_yellow.svg')"/>
	                </span>
				        <div>
				        <span style="display: block;color: grey;">
					        No preview is available for this app at the moment! Check the links below for more details.
				        </span>
				        </div>
			        </div>
		        </div>

		        <!-- Quick links -->
		        <div class="layout-column quick-links-container">
			        <div>
				        <h1 class="title">Quick links</h1>
			        </div>
			        <div>
				        <ul>
					        <li v-for="link in appLinks.links">
						        <external-link :href="link.url" target="_blank" :label="link.title" />
					        </li>
				        </ul>
			        </div>
		        </div>


	        </div>
        </div>
    </div>
</template>

<script>
import API from "@/api"
import Paypal_plugin from "./paypal_plugin";
import Proofy from "./proofy";
import ExternalLink from "@/components/base/external-link";

export default {
    name: "funnel-app-preview",
	components: {ExternalLink, Paypal_plugin, Proofy},
	props: ["app", "userApp", "newUserApp"],
    mixins: [API],
    data() {
        return {
        	appOtherLinks: [
		        {
			        id:3, links:[
				        {title: "Smart Address app tutorial", url:"https://docs.funnelish.com/apps/smart-address-plugin"},
			        ]
		        },
		        {
			        id:4, links:[
				        {title: "Fancy Credit Card app tutorial", url:"https://docs.funnelish.com/apps/fancy-credit-card"},
			        ]
		        },
		        {
			        id:5, links:[
				        {title: "Smart Optin app tutorial", url:"https://docs.funnelish.com/apps/smart-optin"},
				        {title: "How to obtain Facebook Client ID", url:"https://docs.funnelish.com/apps/smart-optin/facebook-client-id"},
				        {title: "How to obtain Google Client ID", url:"https://docs.funnelish.com/apps/smart-optin/google-client-id"},
			        ]
		        },
		        {
			        id:6, links:[
				        {title: "Fancify app tutorial", url:"https://docs.funnelish.com/apps/fancify"},
				        {title: "Setting up product variants using Fancify app", url:"https://docs.funnelish.com/apps/fancify/product-variants"},
			        ]
		        },
		        {
			        id:7, links:[
				        {title: "Programmable app tutorial", url:"https://docs.funnelish.com/apps/using-programmable"},
			        ]
		        },
		        {
			        id:8, links:[
				        {title: "Funnelish Pay tutorial", url:"https://docs.funnelish.com/apps/funnelish-pay"},
				        {title: "Adding PayPal payment option", url:"https://docs.funnelish.com/apps/funnelish-pay/paypal"},
				        {title: "Adding Stripe payment option", url:"https://docs.funnelish.com/apps/funnelish-pay/stripe"},
				        {title: "Adding Cash on Delivery payment option", url:"https://docs.funnelish.com/apps/funnelish-pay/cash-on-delivery"},
			        ]
		        },
		        {
			        id:9, links:[
				        {title: "Proofy tutorial", url:"https://docs.funnelish.com/apps/proofy"},
			        ]
		        },
		        {
			        id:11, links:[
				        {title: "Facebook Pixel app tutorial", url:"https://docs.funnelish.com/apps/facebook-pixel"},
			        ]
		        },
		        {
			        id:12, links:[
				        {title: "Smart Currency Converter app tutorial", url:"https://docs.funnelish.com/apps/smart-currency-converter"},
			        ]
		        },
		        {
			        id:13, links:[
				        {title: "Pinterest Tag app tutorial", url:"https://docs.funnelish.com/apps/pinterest-tag"},
			        ]
		        },
		        {
			        id:14, links:[
				        {title: "Google Analytics app tutorial", url:"https://docs.funnelish.com/apps/google-analytics"},
			        ]
		        },
		        {
			        id:15, links:[
				        {title: "TaxJar app tutorial", url:"https://docs.funnelish.com/apps/taxjar"},
			        ]
		        },
		        {
			        id:16, links:[
				        {title: "Tiktok Pixel app tutorial", url:"https://docs.funnelish.com/apps/tiktok-pixel"},
			        ]
		        },
	        ]
        }
    },
    computed: {
    	appLinks(){
    		let links = this.appOtherLinks.filter(i => i.id==this.userApp.id);
    		if (links.length===0) return {};
    		return links[0];
	    },
    	componentName() {
    		switch (this.app.name) {
			    case "PayPal Plugin":
				    return "paypal_plugin";
			    case "Proofy":
				    return "proofy";
          default:
            return ""
		    }
	    },
    },
    methods: {
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
    .funnel-app-preview {
        padding: 0 0px;
        .head {
	        color: black;
	        border-bottom: 1px solid #e5e6f1;
	        padding: 0 15px 10px;
        }
        .subheadline {
            color: slategrey;
        }
        .content {

        }
    }
</style>
